<template>
  <div class="right d-f f-d a-c">
    <a-menu v-model="current" mode="horizontal">
      <a-menu-item key="account" :disabled="!showAccount">1.注册账号</a-menu-item>
      <a-menu-item key="password" :disabled="!showPassword">2.设置密码</a-menu-item>
    </a-menu>
    <account v-show="showAccount" @canNext="getNextMessage"></account>
    <password v-show="showPassword"></password>
  </div>
</template>

<script>
import Account from "./account.vue";
import Password from "./password.vue";
export default {
  name: "Register",
  components: { Account, Password },
  data() {
    return {
      current: ["account"],
      showAccount: true,
      showPassword: false,
    };
  },
  methods: {
    //收到可以下一步的指令
    getNextMessage() {
      this.showAccount = false;
      this.showPassword = true;
      this.current = ["password"];
    },
  },
};
</script>

<style scoped lang="less">
.right {
  width: 445px;
  height: 613px;
  background-image: url("~@/assets/images/login_right_bac.png");
  background-size: 100% 100%;
  padding: 110px 48px 0;
  box-sizing: border-box;
  .ant-menu-horizontal {
    border-bottom: none;
  }
  .ant-menu-item {
    font-size: 16px;
  }
}
</style>
